//This script is used to toggle the visibility of the robot history accordion content.
//It is used in the robot history page.
document.addEventListener('DOMContentLoaded', function () {
    const accordions = document.querySelectorAll('.accordion-header');
    accordions.forEach((header) => {
        header.addEventListener('click', function () {
            const content = this.nextElementSibling;
            if (
                content.style.display === 'none' ||
                content.style.display === ''
            ) {
                content.style.display = 'block';
            } else {
                content.style.display = 'none';
            }
        });
    });
});

// This script is used to convert the timestamp to user's local time.
// It is used in the status view when progressing scan. TODO:THIS IS NOT WORKING TIMESTAMP FIX
document.addEventListener('DOMContentLoaded', function () {
    function convertToUserTime(selector) {
        const element = document.querySelector(selector);
        if (element) {
            const timestamp = element.getAttribute('data-timestamp');
            if (timestamp) {
                const date = new Date(timestamp);
                element.textContent =
                    element.textContent.split(': ')[0] +
                    ': ' +
                    date.toLocaleString();
            }
        }
    }

    convertToUserTime('#queueTime');
    convertToUserTime('#runningTime');
    convertToUserTime('#endTime');
});
